"use client";

import Image from "next/image";
import defaultImage from "@/public/mock_images/image_01.webp";
import { memo, useMemo } from "react";
import { DRAWER_ROUTES } from "@/constants/drawer";
import { cn } from "@/lib/utils";

type Props = {
  selectedRoute: string | null;
};

const animationStyle = {
  animationDelay: "260ms",
  animationFillMode: "backwards" as const,
};

const baseImageWrapperClasses =
  "absolute inset-0 transition-opacity ease-in-out duration-500 overflow-hidden animate-in fade-in slide-in-from-left-4 will-change-[opacity]";

const gradientOverlayClasses =
  "absolute inset-0 bg-gradient-to-t from-brand-900 via-brand-900/35 to-transparent size-full";

const imageClasses = "object-cover object-center saturate-[1.12]";

function DrawerMenuLinkImagesComponent({ selectedRoute }: Props) {
  const isDefaultVisible = !selectedRoute;

  const defaultWrapperClasses = useMemo(
    () =>
      cn(
        baseImageWrapperClasses,
        isDefaultVisible ? "opacity-100 visible" : "opacity-0 invisible",
      ),
    [isDefaultVisible],
  );

  return (
    <div className="hidden lg:block fixed inset-y-0 left-0 right-[25%] sm:right-[580px] z-[50] pointer-events-none overflow-hidden">
      <div className={defaultWrapperClasses} style={animationStyle}>
        <Image
          alt=""
          className={imageClasses}
          fill
          placeholder="blur"
          sizes="45vw"
          src={defaultImage}
          priority
          quality={95}
        />

        <div className={gradientOverlayClasses} />
      </div>

      {DRAWER_ROUTES.map((route) => {
        const isVisible = selectedRoute === route.label;

        return (
          <div
            className={cn(
              baseImageWrapperClasses,
              isVisible ? "opacity-100 visible" : "opacity-0 invisible",
            )}
            style={animationStyle}
            key={route.label}
          >
            <Image
              alt=""
              className={imageClasses}
              fill
              placeholder="blur"
              sizes="45vw"
              src={route.image}
              quality={95}
              loading="eager"
            />

            <div className={gradientOverlayClasses} />
          </div>
        );
      })}
    </div>
  );
}

export const DrawerMenuLinkImages = memo(DrawerMenuLinkImagesComponent);
